import { createTheme } from "@mui/material/styles";

const theme  = createTheme({
    palette: {
        primary: {
            main: "#1E87FF",
            contrastText: '#fff'     
        },
        secondary: {
            main: "#A0A7AB",
            contrastText: '#fff'  
        },
        success: {
            main: "#2E7D32",
            contrastText: '#fff'  
        },
        recibido: {
            main: '#A0A7AB',
            contrastText: '#fff'
        },
        documentado: {
            main: '#ed6c02',
            contrastText: '#fff'
        },
        transito: {
            main: '#1E87FF',
            contrastText: '#fff'
        },
        entregado: {
            main: '#2E7D32',
            contrastText: '#fff'
        },
        noEntregado: {
            main: '#d32f2f',
            contrastText: '#fff'
        }
    },
    typography: {
        fontFamily: ['Inter'],
        fontSize: 12,
        color: 'black !important',
        userName: {
            fontWeight: 600,
            fontSize: 14,
            '@media(max-width: 600px)' : {
                fontSize: 12
            },
            '@media(max-width: 430px)' : {
                display: 'none'
            }
        },
        h4: {
            fontSize: 20,
            fontWeight: 600,
            textTransform: 'uppercase',
            '@media(max-width: 1400px)' : {
                fontSize: 16
            }
        },
        h6: {
            fontWeight: 600,
            fontSize: 14
        },
        caption: {
            fontSize: 12
        },
        labelBold:{
            fontSize: 12,
            fontWeight: 600
        },
        estatus: {
            fontSize: 16,
            fontWeight: 600,
            '@media(max-width: 1400px)' : {
                fontSize: 12
            }
        },
        message: {
            color: "#000",
            fontWeight: 500
        },
        unauth: {
            fontSize: 40,
            color: "#757575",
            fontWeight: 600,
            
        }
    },
    components: {
        MuiSvgIcon: {
            defaultProps: {
                fontSize: 'inherit'
            }
        },
        MuiCardContent: {
            variants: [
                {
                    props: { variant: 'smallCard'},
                    style: {
                        padding: '10px 20px !important'                        
                    }
                }
            ]
        },
        MuiIconButton: {
            defaultProps: {
                color: "inherit"
            },
            variants: [
                {
                    props: { variant: 'closeIcon'},
                    style: {
                        padding: '0px !important'
                    }
                }
            ]
        },
        MuiButton: {
            variants: [
                {
                    props: {variant: "export"},
                    style: {
                        backgroundColor: "#1BA466",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#1F7244",
                        }
                    }
                }
            ],
        },
        // MuiDialogTitle: {
        //     defaultProps: {
        //         bgcolor: "primary.main",
        //         color: "white !important"
        //     }
        // },
        MuiDialogActions: {
            variants: [
                {
                    props: { variant: 'paddi'},
                    style: {
                        padding: '10px 24px',
                        paddingTop: '0px'
                    }
                }
            ]
        },
        MuiContainer: {
            styleOverrides: {
                // Name of the slot
                root: {
                    paddingRight: '24px !important',
                    paddingLeft: '24px !important',
                    '@media(min-width: 1366px)' : {
                        paddingRight: '0px !important',
                        paddingLeft: '0px !important'
                    },
                    '@media(max-width: 480px)' : {
                        paddingRight: '0px !important',
                        paddingLeft: '0px !important'
                    }
                }
            },
        }
    }
})

export default theme;